import React from 'react';
import './Group.css';
import GroupLogin from './GroupLogin/GroupLogin';
import GroupAction from './GroupAction/GroupAction';

function importAll(r) {
    let images = {};
    r.keys().map((item, index) => images[item.replace('./', '')] = r(item));
    return images;
}

const images = importAll(require.context('../../../assets/img/flags', false, /\.(svg)$/));

let Group = props => {
    return (
        <div className="group">
            <div className="wrapper">
                <h4>{props.group.name}</h4>
                <p>Teams</p>

                <ul>
                    {props.group.countries.map(country => (
                        <li key={country.id}>
                            <figure><img src={images[`${country.abr}.svg`]} alt={country.name}/></figure>
                            <span>{country.name}</span>
                        </li>
                    ))}
                </ul>
            </div>
            {
                props.user.name?
                    <GroupAction enterResults={() => { props.enterResults(props.group, props.index) }}/>:
                    <GroupLogin getLogin={props.getLogin}/>
            }
        </div>
    );
};

export default Group;


// WEBPACK FOOTER //
// ./src/components/Groups/Group/Group.jsx